import { render } from "./AdminResourceContent.vue?vue&type=template&id=1321cd68"
import script from "./AdminResourceContent.vue?vue&type=script&lang=js"
export * from "./AdminResourceContent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__